import Vue from 'vue';
import sk from 'vee-validate/dist/locale/sk';
import {
    ValidationProvider,
    ValidationObserver,
    localize
} from 'vee-validate/dist/vee-validate.full.esm';

// Localize takes the locale object as the second argument (optional) and merges it.
localize('sk', sk);

// Install the Plugin.
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);